import type { PropsWithChildren } from "react";

import { Flex } from "@aircall/tractor";

import type { PlaygroundSectionLayoutProps } from ".";

export function PlaygroundSectionLayout({
  children,
  ...props
}: PropsWithChildren<PlaygroundSectionLayoutProps>) {
  return (
    <Flex gap="m" flexDirection="column" {...props}>
      {children}
    </Flex>
  );
}
